import React from 'react';

import styled from 'styled-components';

interface Props {
  src: string;
}

const StyledImage = styled.img`
  align-self: center;
`;

const Image = ({ src }: Props) => <StyledImage src={src} />;

export default Image;
